import moment from "moment"

export function format_date(value, format_tanggal) {
  if (value) {
    return moment(String(value)).format(format_tanggal)
  }
}

export function checkRole(value) {
  if (value === 'prov') {
    return 'provinsi'
  } else if (value === 'kabkot') {
    return 'kabkot'
  }
}

export function checkRolebyNama(value) {
  if (value.includes("Provinsi")) {
    return 'provinsi'
  } else if (value.includes("Kabupaten") || value.includes("Kota") || value.includes("KAB.") || value.includes("KOTA")) {
    return 'kabkot'
  } else {
    return ''
  }
}
